import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import * as API from "../../framework/API/api";
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import ToastNotification from '../../components/ToastNotification';

const PlatformGroupsEditForm = () => {

    const lang = useTranslation();
    const navigate = useNavigate();
    const { SID } = useParams();
    const loc = useLocation();

    const blankDataItem = {
        Description: "",
        Archive: false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [showLinkedPlatform, setShowLinkedPlatform] = useState(false);
    const [gridDataLinkedPlatforms, setGridDataLinkedPlatforms] = useState([]);

    useEffect(() => {
        if (SID > 0) { loadEditData(); }
    }, []);

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const loadEditData = async () => {
        let res = await API.getEntity(ENTITYNAME.PlatformGroups, parseInt(SID));
        if (res?.success && res?.data) {
            const groupData = res?.data;
            setDataItem({ ...groupData, Description: loc.state?.copy ? "Copy of " + groupData.Description : groupData.Description });

            let platformRes = await API.getData(ENTITYNAME.Platform);
            if (platformRes.success) {
                const mappedLinkedChannels = (groupData.LinkedPlatforms ?? []).map(x => {
                    const channel = platformRes.data.find(p => p._id === x._id);
                    return {
                        _id: x?._id,
                        SID: x?.SID,
                        Description: x?.Description
                    };
                });
                setGridDataLinkedPlatforms(mappedLinkedChannels);
            }
        }
    };

    const isValid = () => {
        if (dataItem.Description == "" || dataItem.Description == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        let finalData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            Description: dataItem?.Description,
            LinkedPlatforms: gridDataLinkedPlatforms?.length > 0 ? gridDataLinkedPlatforms?.map((x) => {
                return {
                    _id: x?._id,
                    SID: x?.SID,
                    Description: x?.Description
                }
            }) : [],
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]],
        }
        if (loc?.state?.copy) {
            delete finalData._id;
            delete finalData.SID;
        }
        console.log(finalData)
        let res = await API.saveData(ENTITYNAME.PlatformGroups, finalData);
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PLATFORM_GROUPS, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.PlatformGroups);
        if (!res.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        } else {
            navigate(-1);
        }
    }
    const removeGridData = (dataItem) => {
        setGridDataLinkedPlatforms(gridDataLinkedPlatforms.filter((obj) => dataItem._id != obj._id));
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    }
    const MyCommandCell = (props) => (
        <td style={{ padding: "3px" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeGridData(props.dataItem), () => { })} />
        </td>
    )
    const handleGridLinkedPlatform = (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, gridDataLinkedPlatforms, "Description")
        setGridDataLinkedPlatforms([...gridDataLinkedPlatforms, ...newData]);
    }

    return (
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader title={dataItem?.Description != "" ? dataItem?.Description : lang.platform_groups_header} onSubmit={handleSubmit} onCancel={() => navigate(-1)} />
                <div className="row">
                    <div className="col-6">
                        <label htmlFor="">{lang.description_label}*</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="Description"
                            value={dataItem.Description}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-4">
                        <input
                            name="Archive"
                            type="checkbox"
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange}
                        />
                        <label className="ml-1">{lang.archive}</label>
                    </div>
                </div>
                <div>
                    <AddRoundButton onClick={() => setShowLinkedPlatform(true)} style={{ marginTop: "20px", marginLeft: "5px" }} />
                    <span className='float-right mr-3' style={{ marginTop: "36px" }}>{lang.platform_groups_label}</span>
                    <Grid style={{ height: "65vh", margin: '0px 10px 40px 10px', overflow: "hidden" }} className="mt-2" data={gridDataLinkedPlatforms}>
                        <GridColumn cell={MyCommandCell} width="40px" locked />
                        <GridColumn field="Description" title={lang.platform_column} width={"250px"} />
                    </Grid>
                </div>
            </div>
            {showLinkedPlatform && <CollectionSelection setDataList={handleGridLinkedPlatform} closeForm={() => setShowLinkedPlatform(false)} entityname={ENTITYNAME.Platform} width={"50vw"} title={lang.select_platform_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
        </div >
    )
}

export default PlatformGroupsEditForm